/* libs */
import React, { Component } from "react";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter, Prompt } from "react-router-dom";
import { isEmpty, cloneDeep } from "lodash";

import * as controlPanelActions from "../../actions/controlPanelActions";
import ErrorHandler from "../../helpers/validation/errorHandler";

/* components */
import { Form } from "informed";

const formWrapper = (WrappedForm, shouldPrompt = true) => {
	class FormWrapper extends Component {
		constructor(props) {
			super(props);
			this.updateForm = this.updateForm.bind(this);

			this.state = {
				values: isEmpty(props.initialValues) ? {} : props.initialValues,
				errors: [],
				unsaved: false,
				formApi: null,
				isSaving: false,
			};
		}

		updateForm(formState) {
			// console.log(formState);
			// console.log("Values: ", formState.values);

			let unsaved = this.state.unsaved || Object.keys(formState.touched).length > 0;
			this.setState({
				values: cloneDeep(formState.values),
				unsaved,
			});
		}

		promptUnsavedChange(
			isUnsaved = false,
			leaveMessage = "Your changes are unsaved. Are you sure you want to leave?"
		) {
			// Detecting browser close
			window.onbeforeunload = isUnsaved && (() => leaveMessage);
		}

		onSubmit = values => {
			this.setState({ unsaved: false, isSaving: true });
			this.props.onSubmit(values, this.submitHandler);
		};

		onSubmitFailure = (errors, asyncErrors) => {
			if (window.$(".has-error").length > 0) {
				var obj = window.$(".has-error").first();
				obj.parents(".panel").each(function() {
					if (
						!window
							.$(this)
							.find(".panel-toggle")
							.hasClass("open")
					) {
						window
							.$(this)
							.children(".panel-heading")
							.click();
					}
				});
				setTimeout(() => {
					window.$("html, body").animate(
						{
							scrollTop: obj.offset().top - 100,
						},
						500
					);
					this.props.controlPanelActions.hideLoading();
				}, 0);
			}
			if (this.props.onError) {
				this.props.onError(errors, asyncErrors);
			}
		};

		submitHandler = (successful, results) => {
			this.props.controlPanelActions.hideLoading();
			if (!successful) {
				this.setState({ isSaving: false }, () => {
					ErrorHandler(results, this.state.formApi, this.props.controlPanelActions);
				});
			}
		};

		getApi = formApi => {
			this.setState({ formApi });
			if (this.props.getApi) {
				this.props.getApi(formApi);
			}
		};

		submitForm = (formApi, showLoader) => {
			if (showLoader) this.props.controlPanelActions.showLoading();
			formApi.submitForm();
		};

		render() {
			const { values } = this.state;

			return (
				<div className="form-wrapper">
					<Form
						onSubmit={this.onSubmit}
						onChange={this.updateForm}
						initialValues={this.props.initialValues}
						getApi={this.getApi}
						onSubmitFailure={this.onSubmitFailure}
					>
						{({ formApi }) => (
							<WrappedForm
								{...this.props}
								formApi={formApi}
								values={values}
								submitForm={(showLoader = false) => this.submitForm(formApi, showLoader)}
							/>
						)}
					</Form>
					<Prompt
						when={this.state.unsaved && !this.state.isSaving && shouldPrompt}
						message={location => {
							const { themeNav } = this.props;
							const isViewRoute = themeNav.map(e => e.route).includes(location.pathname.split("/").pop());
							return isViewRoute ? true : "Your changes are unsaved. Are you sure you want to leave?";
						}}
					/>
				</div>
			);
		}
	}

	FormWrapper.propTypes = {
		getValues: PropTypes.func,
		onSubmit: PropTypes.func,
		onError: PropTypes.func,
		initialValues: PropTypes.object,
		errors: PropTypes.array,
		getApi: PropTypes.func,
		route: PropTypes.object,
		router: PropTypes.object,
		controlPanelActions: PropTypes.object,
	};
	const mapStateToProps = state => ({
		errors: state.validation.errors,
		themeNav: state.themes.themeNav,
	});

	const mapDispatchToProps = dispatch => ({
		controlPanelActions: bindActionCreators(controlPanelActions, dispatch),
	});

	return connect(
		mapStateToProps,
		mapDispatchToProps
	)(withRouter(FormWrapper));
};

export default formWrapper;
